import { setSaveWorkflowHistory, workflowHistoryState, workflowNotSaveHistory } from "pages/settings/workflows/EditWorkflow"
import { InputField, WorkflowDefs } from "pages/settings/workflows/workflow.defs"
import { CategoryEnum } from "pages/settings/workflows/workflow.enums"
import { Elements } from "react-flow-renderer"
import { atom } from "jotai"

export const workflowActiveRunNodeAtom = atom<string>("1")

export const workflowActiveRunEdgeAtom = atom<string>("")

export const workflowRunBotOnStepAtom = atom<boolean>(false)

export const workflowSelectedElementsAtom = atom<Elements | []>([])

export const workflowConnectingAtom = atom<string | undefined | boolean>(undefined)

// Estado real dos elementos
const baseWorkflowElementsAtom = atom<Elements | []>([])

// Atom com interceptação de set para salvar no histórico
// export const workflowElementsAtom = atom(
//   (get) => get(baseWorkflowElementsAtom),
//   (get, set, newValue: Elements | []) => {
//     set(baseWorkflowElementsAtom, newValue)

//     if (!workflowNotSaveHistory) {
//       workflowHistoryState?.push({ elements: newValue })
//     }
//     setSaveWorkflowHistory(false)
//   },
// )
type Updater<T> = (prev: T) => T

export const workflowElementsAtom = atom(
  (get) => get(baseWorkflowElementsAtom),
  (get, set, update) => {
    const prev = get(baseWorkflowElementsAtom)
    const next =
      typeof update === 'function'
        ? (update as Updater<Elements>)(prev)
        : (update as Elements)

    // Evita trabalho/histórico desnecessário (opcional)
    // if (Object.is(prev, next)) {
    //   setSaveWorkflowHistory(false)
    //   return
    // }

    set(baseWorkflowElementsAtom, next)

    if (!workflowNotSaveHistory) {
      workflowHistoryState?.push({ elements: next })
    }
    setSaveWorkflowHistory(false)
  },
)

export const editWorkflowNodeIdAtom = atom<string | undefined>("")

export const quickViewWorkflowNodeIdAtom = atom<string | undefined>("")

export const workflowVariablesAtom = atom<
  {
    nodeId: string
    nodeType: string
  }[]
>([])

export interface ReceivedWebhookMonitor {
  query: any
  body: any
  origin: string
  referer: string
  webhookId: string
}

export const receivedWebhookMonitorAtom = atom<ReceivedWebhookMonitor | undefined>(undefined)

export const searchVisibleAtom = atom<boolean>(false)

export const entityFieldsAtom = atom<
  Record<
    CategoryEnum,
    {
      record: Record<string, InputField>
      array: InputField[]
    }
  >
>(WorkflowDefs.Fields)
